module.exports = __webpack_public_path__ + "img/Logo_acronis.07b7264f.svg";